import MyListHeader from '@ulta/components/MyListHeader/MyListHeader';

export default MyListHeader;